/* Power in Sports — JS del tema (sin dependencias) */
(() => {
  'use strict';

  const theme = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const debounce = (fn, wait = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Dinero ---------- */
  function formatMoney(cents, format = theme.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseInt(cents, 10) || 0;
    const fmt = (n, dec = 2, th = ',', dc = '.') => {
      const fixed = (n / 100).toFixed(dec);
      const [i, d] = fixed.split('.');
      return i.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${th}`) + (d ? dc + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2);
        case 'amount_no_decimals': return fmt(value, 0);
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(value, 0, ' ', '');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(value, 2, ' ', '.');
        default: return fmt(value, 2);
      }
    });
  }
  theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }
  theme.toast = toast;

  /* ---------- Drawers (menú, carrito, filtros) ---------- */
  let lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = drawer.querySelector('[data-autofocus], button, a, input');
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 60);
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-overlay.is-open')) document.body.classList.remove('is-locked');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  theme.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const drawer = document.getElementById(opener.dataset.drawerOpen);
      if (drawer) { e.preventDefault(); openDrawer(drawer); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
  });

  // Trampa de foco dentro de capas abiertas
  document.addEventListener('keydown', (e) => {
    const layer = $('.drawer.is-open, .search-overlay.is-open, .lightbox.is-open');
    if (!layer) return;
    if (e.key === 'Escape') {
      if (layer.classList.contains('drawer')) closeDrawer(layer);
      else if (layer.classList.contains('search-overlay')) closeSearch();
      else closeLightbox();
      return;
    }
    if (e.key !== 'Tab') return;
    const items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', layer)
      .filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Barra de anuncios (rotación en móvil) ---------- */
  $$('[data-announce]').forEach((bar) => {
    const items = $$('.announce__item', bar);
    if (items.length < 2) return;
    let i = 0;
    items[0].classList.add('is-active');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Mega menú ---------- */
  $$('[data-nav-item]').forEach((item) => {
    const trigger = $('.nav__link', item);
    const panel = $('.mega', item);
    if (!trigger || !panel) return;
    let closeT;
    const open = () => {
      clearTimeout(closeT);
      $$('[data-nav-item].is-open').forEach((o) => { if (o !== item) { o.classList.remove('is-open'); $('.nav__link', o).setAttribute('aria-expanded', 'false'); } });
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const close = () => { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => { closeT = setTimeout(close, 160); });
    trigger.addEventListener('click', (e) => {
      if (!item.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); trigger.focus(); } });
  });

  /* ---------- Búsqueda predictiva ---------- */
  const searchOverlay = $('#SearchOverlay');
  function openSearch() {
    if (!searchOverlay) return;
    lastFocus = document.activeElement;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(() => { const i = $('input[type="search"]', searchOverlay); i && i.focus(); }, 80);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  if (searchOverlay) {
    const input = $('input[type="search"]', searchOverlay);
    const results = $('[data-predictive-results]', searchOverlay);
    const quick = $('[data-search-quick]', searchOverlay);
    let controller;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; quick && (quick.hidden = false); return; }
      quick && (quick.hidden = true);
      controller && controller.abort();
      controller = new AbortController();
      try {
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parseHTML(await res.text());
        const node = doc.querySelector('[data-predictive-content]');
        results.innerHTML = node ? node.innerHTML : '';
      } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
    }, 220);
    input && input.addEventListener('input', run);
  }

  /* ---------- Carrito ---------- */
  const drawerSection = 'cart-drawer';

  function setCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.dataset.count = count;
    });
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = parseHTML(html);
      const fresh = doc.querySelector('[data-cart-root]');
      const target = document.querySelector(`[data-cart-root][data-section="${id}"]`);
      if (fresh && target) target.replaceWith(fresh);
      if (fresh && fresh.dataset.countValue !== undefined) setCartCount(parseInt(fresh.dataset.countValue, 10));
    });
  }

  function cartSectionIds() {
    return $$('[data-cart-root]').map((el) => el.dataset.section).filter(Boolean);
  }

  async function addToCart(form, button) {
    const fd = new FormData(form);
    const sections = cartSectionIds();
    if (sections.length) {
      fd.append('sections', sections.join(','));
      fd.append('sections_url', window.location.pathname);
    }
    button && button.classList.add('is-loading');
    button && button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.cartError);
      if (data.sections) renderCartSections(data.sections);
      else refreshCount();
      const drawer = $('#CartDrawer');
      if (drawer && theme.cartType === 'drawer') openDrawer(drawer);
      else toast(theme.strings.added);
      if (button && button.classList.contains('quick-add__btn')) {
        button.classList.add('is-done');
        setTimeout(() => button.classList.remove('is-done'), 1600);
      }
      const panel = form.closest('.quick-add__panel');
      if (panel) panel.hidden = true;
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    } catch (err) {
      toast(err.message || theme.strings.cartError);
    } finally {
      button && button.classList.remove('is-loading');
      button && button.removeAttribute('aria-busy');
    }
  }

  async function refreshCount() {
    try { const c = await (await fetch(`${theme.routes.cart}.js`)).json(); setCartCount(c.item_count); } catch (_) {}
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector('[type="submit"]');
    addToCart(form, btn);
  });

  async function changeLine(line, quantity, root) {
    const list = root && root.querySelector('.line-items');
    list && list.classList.add('is-busy');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.cartError);
      renderCartSections(data.sections);
      setCartCount(data.item_count);
    } catch (err) {
      toast(err.message || theme.strings.cartError);
      list && list.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const root = e.target.closest('[data-cart-root]');
    const remove = e.target.closest('[data-line-remove]');
    if (remove && root) { e.preventDefault(); changeLine(parseInt(remove.dataset.lineRemove, 10), 0, root); return; }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('.qty');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const min = parseInt(input.min || '0', 10);
      const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      if (next === parseInt(input.value, 10)) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) {
      const root = input.closest('[data-cart-root]');
      changeLine(parseInt(input.dataset.lineQty, 10), Math.max(0, parseInt(input.value, 10) || 0), root);
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(`${theme.routes.cart}/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value })
      });
    }
  });

  /* ---------- Agregar rápido (tarjetas) ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-quick-open]');
    if (open) {
      const panel = document.getElementById(open.getAttribute('aria-controls'));
      if (!panel) return;
      $$('.quick-add__panel').forEach((p) => { if (p !== panel) p.hidden = true; });
      panel.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      const sel = $('select', panel); sel && sel.focus();
      return;
    }
    const close = e.target.closest('[data-quick-close]');
    if (close) {
      const panel = close.closest('.quick-add__panel');
      panel.hidden = true;
      const btn = document.querySelector(`[aria-controls="${panel.id}"]`);
      btn && (btn.setAttribute('aria-expanded', 'false'), btn.focus());
      return;
    }
    if (!e.target.closest('.quick-add')) $$('.quick-add__panel:not([hidden])').forEach((p) => { p.hidden = true; });
  });

  /* ---------- Rieles horizontales ---------- */
  // Un "scope" agrupa flechas y uno o varios rieles (p. ej. pestañas); las flechas mueven el riel visible.
  function initRail(scope) {
    if (!scope || scope.dataset.railReady) return;
    scope.dataset.railReady = '1';
    const prev = $('[data-rail-prev]', scope);
    const next = $('[data-rail-next]', scope);
    const active = () => $$('.rail__track', scope).find((t) => t.offsetParent !== null);
    const update = () => {
      const t = active();
      if (!t) return;
      const max = t.scrollWidth - t.clientWidth - 4;
      if (prev) prev.disabled = t.scrollLeft <= 4;
      if (next) next.disabled = t.scrollLeft >= max;
      const nav = prev && prev.parentElement;
      if (nav) nav.hidden = max <= 0;
    };
    const by = (dir) => { const t = active(); t && t.scrollBy({ left: dir * t.clientWidth * 0.85, behavior: 'smooth' }); };
    prev && prev.addEventListener('click', () => by(-1));
    next && next.addEventListener('click', () => by(1));
    $$('.rail__track', scope).forEach((t) => t.addEventListener('scroll', debounce(update, 60), { passive: true }));
    window.addEventListener('resize', debounce(update, 150));
    scope.addEventListener('rail:update', update);
    update();
  }
  $$('[data-rail-scope]').forEach(initRail);

  /* ---------- Pestañas ---------- */
  $$('[data-tabs]').forEach((scope) => {
    const tabs = $$('[role="tab"]', scope);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      scope.dispatchEvent(new CustomEvent('rail:update'));
      const link = $('[data-tab-link]', scope);
      if (link && tab.dataset.url) { link.href = tab.dataset.url; }
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  });


  /* ---------- Slider (MAMAO) ---------- */
  $$('[data-slider]').forEach((root) => {
    const slides = $$('.mslider__slide', root);
    const dots = $$('[data-slide-to]', root);
    if (slides.length < 2) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const secs = parseInt(root.dataset.autoplay || '0', 10);
    const ms = secs * 1000;
    root.style.setProperty('--slide-ms', `${ms || 6000}ms`);
    let i = 0, timer = null;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.inert = !on;
        $$('a.btn', s).forEach((a) => { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach((d, k) => {
        d.setAttribute('aria-current', 'false');
        if (k === i) { void d.offsetWidth; requestAnimationFrame(() => d.setAttribute('aria-current', 'true')); }
      });
    };
    const play = () => { if (!ms || reduce) return; stop(); root.dataset.playing = ''; timer = setInterval(() => go(i + 1), ms); };
    const stop = () => { clearInterval(timer); delete root.dataset.playing; };
    $('[data-slide-prev]', root)?.addEventListener('click', () => { go(i - 1); play(); });
    $('[data-slide-next]', root)?.addEventListener('click', () => { go(i + 1); play(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.slideTo, 10)); play(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      play();
    });
    document.addEventListener('shopify:block:select', (e) => { const k = slides.indexOf(e.target); if (k > -1) { stop(); go(k); } });
    go(0); play();
  });

  /* ---------- Producto ---------- */
  class ProductInfo {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('form[data-product-form]', root);
      this.idInput = this.form && $('input[name="id"]', this.form);
      this.gallery = $('[data-gallery]', root);
      this.sticky = $('[data-sticky-atc]');
      this.lowStock = parseInt(root.dataset.lowStock || '0', 10);
      root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) this.onChange(); });
      this.markAvailability();
    }
    selected() {
      return $$('[data-option-index]', this.root).reduce((acc, el) => {
        const idx = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT') acc[idx] = el.value;
        else if (el.checked) acc[idx] = el.value;
        return acc;
      }, []);
    }
    onChange() {
      const opts = this.selected();
      let variant = this.product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      this.markAvailability();
      this.update(variant);
    }
    markAvailability() {
      const opts = this.selected();
      $$('input[data-option-index]', this.root).forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        const ok = this.product.variants.some((v) => v.available && v.options[idx] === input.value &&
          v.options.every((o, i) => i === idx || i > idx || o === opts[i]));
        input.classList.toggle('is-unavailable', !ok);
      });
      $$('[data-option-value]', this.root).forEach((el) => {
        const idx = parseInt(el.dataset.optionIndex, 10);
        if (opts[idx] !== undefined) el.textContent = opts[idx];
      });
    }
    update(variant) {
      const btns = $$('[data-add-button]');
      const s = theme.strings;
      if (!variant) {
        btns.forEach((b) => { b.disabled = true; $('[data-add-text]', b).textContent = s.unavailable; });
        this.setStock(null);
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;
      btns.forEach((b) => { b.disabled = !variant.available; $('[data-add-text]', b).textContent = variant.available ? s.addToCart : s.soldOut; });

      $$('[data-price-wrap]').forEach((wrap) => {
        const price = $('.price__current', wrap);
        const compare = $('.price__compare', wrap);
        const from = $('.price__from', wrap);
        from && from.remove();
        price && (price.textContent = formatMoney(variant.price));
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        $('.price', wrap) && $('.price', wrap).classList.toggle('price--sale', !!sale);
        if (compare) { compare.hidden = !sale; if (sale) compare.lastChild.textContent = formatMoney(variant.compare_at_price); }
        const save = $('[data-save]', wrap);
        if (save) {
          save.hidden = !sale;
          if (sale) save.textContent = save.dataset.template.replace('[amount]', formatMoney(variant.compare_at_price - variant.price));
        }
      });
      $$('[data-sku]', this.root).forEach((el) => { el.textContent = variant.sku || ''; el.parentElement.hidden = !variant.sku; });
      this.setStock(variant);
      $$('[data-variant-title]').forEach((el) => { el.textContent = this.product.variants.length > 1 ? variant.title : ''; });

      if (variant.featured_media && this.gallery) this.gallery.goToMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      const wa = $('[data-wa-link]', this.root);
      if (wa && wa.dataset.base) wa.href = wa.dataset.base.replace('%5BVARIANT%5D', encodeURIComponent(variant.title));
    }
    setStock(variant) {
      const el = $('[data-stock]', this.root);
      if (!el) return;
      el.classList.remove('is-low', 'is-out');
      if (!variant || !variant.available) { el.classList.add('is-out'); el.textContent = variant ? theme.strings.soldOut : theme.strings.unavailable; return; }
      const qty = variant.inventory_quantity;
      if (this.lowStock && variant.inventory_management && qty > 0 && qty <= this.lowStock) {
        el.classList.add('is-low');
        el.textContent = theme.strings.lowStock.replace('[count]', qty);
      } else el.textContent = theme.strings.inStock;
    }
  }

  class Gallery {
    constructor(root) {
      this.root = root;
      this.track = $('.gallery__track', root);
      this.slides = $$('.gallery__slide', root);
      this.thumbs = $$('.gallery__thumb', root);
      this.dots = $$('.gallery__dots button', root);
      root.goToMedia = (id) => {
        const i = this.slides.findIndex((s) => s.dataset.mediaId == id);
        if (i > -1) this.go(i);
      };
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
      $('[data-gallery-prev]', root)?.addEventListener('click', () => this.go(Math.max(0, this.index - 1)));
      $('[data-gallery-next]', root)?.addEventListener('click', () => this.go(Math.min(this.slides.length - 1, this.index + 1)));
      this.index = 0;
      this.track && this.track.addEventListener('scroll', debounce(() => {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.mark(i);
      }, 50), { passive: true });
      $$('[data-zoom]', root).forEach((btn) => btn.addEventListener('click', () => openLightbox(this.slides, parseInt(btn.dataset.zoom, 10))));
      const initial = this.slides.findIndex((s) => s.dataset.mediaId === root.dataset.initialMedia);
      if (initial > 0) requestAnimationFrame(() => { this.track.scrollLeft = initial * this.track.clientWidth; this.mark(initial); });
    }
    go(i) {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.mark(i);
    }
    mark(i) {
      this.index = i;
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i));
      this.slides.forEach((s, n) => {
        if (n !== i) s.querySelectorAll('video').forEach((v) => v.pause());
      });
    }
  }

  /* Lightbox */
  const lightbox = $('[data-lightbox]');
  function openLightbox(slides, index) {
    if (!lightbox) return;
    const track = $('.lightbox__track', lightbox);
    track.innerHTML = '';
    slides.forEach((s) => {
      const src = s.dataset.full;
      if (!src) return;
      const img = new Image();
      img.src = src; img.alt = s.dataset.alt || '';
      track.appendChild(img);
    });
    lightbox.classList.add('is-open');
    document.body.classList.add('is-locked');
    requestAnimationFrame(() => { track.scrollLeft = index * track.clientWidth; $('.lightbox__close', lightbox).focus(); });
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  lightbox && $('.lightbox__close', lightbox).addEventListener('click', closeLightbox);

  $$('[data-gallery]').forEach((g) => new Gallery(g));
  $$('[data-product-info]').forEach((p) => new ProductInfo(p));

  /* Barra fija de compra */
  const sticky = $('[data-sticky-atc]');
  const mainBtn = $('[data-main-add]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-sticky-atc', show);
    });
    io.observe(mainBtn);
  }

  /* ---------- Recomendaciones ---------- */
  $$('[data-recommendations]').forEach((el) => {
    const load = async () => {
      try {
        const res = await fetch(el.dataset.url);
        const doc = parseHTML(await res.text());
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          const sec = el.closest('[data-rec-section]');
          sec && sec.classList.add('section');
          $$('[data-rail-scope]', el).forEach(initRail);
        } else {
          const section = el.closest('.shopify-section');
          (section || el).remove();
        }
      } catch (_) {}
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Filtros de colección / búsqueda ---------- */
  const facetRoot = $('[data-facets-root]');
  if (facetRoot) {
    const sectionId = facetRoot.dataset.section;
    const containers = ['[data-results]', '[data-facets-side]', '[data-facets-drawer]', '[data-active-filters]', '[data-product-count]', '[data-filter-count]'];

    const render = async (search, push = true) => {
      const results = $('[data-results]');
      results && results.classList.add('is-loading');
      const params = new URLSearchParams(search);
      params.set('section_id', sectionId);
      try {
        const res = await fetch(`${window.location.pathname}?${params.toString()}`);
        const doc = parseHTML(await res.text());
        containers.forEach((sel) => {
          const fresh = doc.querySelector(sel);
          $$(sel).forEach((old) => { if (fresh) old.innerHTML = fresh.innerHTML; });
        });
        params.delete('section_id');
        const qs = params.toString();
        if (push) history.pushState({ facets: qs }, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
      } catch (_) {
        window.location.search = search;
      } finally {
        $('[data-results]') && $('[data-results]').classList.remove('is-loading');
      }
    };

    const fromForm = (form) => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') params.append(k, v); }
      const sort = $('[data-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      const q = new URLSearchParams(window.location.search).get('q');
      if (q && !params.has('q')) params.set('q', q);
      return params.toString();
    };

    const onChange = debounce((form) => render(fromForm(form)), 350);
    document.addEventListener('change', (e) => {
      const form = e.target.closest('form[data-facet-form]');
      if (form) { onChange(form); return; }
      if (e.target.matches('[data-sort]')) {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', e.target.value);
        params.delete('page');
        render(params.toString());
      }
    });
    document.addEventListener('input', (e) => {
      const form = e.target.closest('form[data-facet-form]');
      if (form && e.target.type === 'number') onChange(form);
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-facet-form]');
      if (form) { e.preventDefault(); render(fromForm(form)); }
    });
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      render(new URL(link.href, window.location.origin).searchParams.toString());
    });
    window.addEventListener('popstate', () => render(window.location.search.slice(1), false));
  }

  /* ---------- Formulario de newsletter: aviso al enviarse ---------- */
  $$('[data-scroll-to-form]').forEach((el) => el.scrollIntoView({ block: 'center' }));
})();
